module.exports = __webpack_public_path__ + "static/media/wordmark.eec2bafb.svg";